import * as Sentry from '@sentry/react';
import { get } from 'lodash';

import { messagesToIgnore } from '../constants/messagesToIgnore';

export const beforeSend = (
  event: Sentry.Event,
  hint: Sentry.EventHint,
): Sentry.Event | null => {
  const error: unknown = get(hint, 'originalException');
  const errorCode: string = get(error, 'code', '');
  const errorRequestUrl: string = get(error, 'config.url', '');

  // We extract the error message from the Sentry event because
  // the originalException from hint could be of different types
  // such as an Array or AxiosError. The event exception value is consistently reliable.
  const errorMessage: string = get(event, 'exception.values.0.value', '');

  const isNetworkError = errorCode === 'ERR_NETWORK';
  const isTimeoutError = errorCode === 'ECONNABORTED';

  const shouldIgnoreByMessage = messagesToIgnore.some((message) =>
    errorMessage.includes(message),
  );

  const shouldIgnoreUnleashError =
    (isNetworkError || isTimeoutError) &&
    errorRequestUrl.includes('us.app.unleash-hosted.com');

  if (shouldIgnoreByMessage || shouldIgnoreUnleashError) {
    return null;
  }

  return event;
};
